const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function postForm(
  path: string,
  payload: Record<string, string>,
): Promise<{ ok: boolean; detail: string }> {
  try {
    const res = await fetch(`${API}${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const data = await res.json().catch(() => null);
    if (res.ok) return { ok: true, detail: data?.message ?? "" };
    const detail =
      typeof data?.detail === "string"
        ? data.detail
        : data?.message || `HTTP ${res.status}`;
    return { ok: false, detail };
  } catch {
    return {
      ok: false,
      detail: "Network error — the form service is not reachable.",
    };
  }
}
